import { getFourDimensionalValue } from './common.js';

var transform4DimensionalDirectionalLogicalProperty = function transform4DimensionalDirectionalLogicalProperty(properties) {
  return function (value) {
    var _getFourDimensionalVa = getFourDimensionalValue(value),
        blockStartValue = _getFourDimensionalVa.blockStartValue,
        blockEndValue = _getFourDimensionalVa.blockEndValue,
        inlineStartValue = _getFourDimensionalVa.inlineStartValue,
        inlineEndValue = _getFourDimensionalVa.inlineEndValue;

    return {
      base: "\n          ".concat(properties.blockStartProperty, ": ").concat(blockStartValue, ";\n          ").concat(properties.blockEndProperty, ": ").concat(blockEndValue, ";\n          ").concat(properties.inlineStartProperty, ": ").concat(inlineStartValue, ";\n          ").concat(properties.inlineEndProperty, ": ").concat(inlineEndValue, ";\n      ")
    };
  };
};

export { transform4DimensionalDirectionalLogicalProperty };
